import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withStyles,
} from "@material-ui/core/";
import Slide from "@material-ui/core/Slide";
import { useTranslations } from "adapters/i18n";
import React from "react";

const transitionDialog = (props) => {
  return <Slide direction="up" {...props} />;
};

export const DialogoConfirmacaoAcao = (props) => {
  const {
    tituloDialog,
    textoDialog,
    dialogAberto,
    aoFecharDialog,
    cancelarAcaoDialog,
    objetoSelecionado,
    excluir,
    textClasses,
    dialogClasses,
  } = props;

  const { t } = useTranslations();

  const confirmar = async (Id) => {
    await excluir(Id);
    cancelarAcaoDialog();
  };

  return (
    <Dialog
      TransitionComponent={transitionDialog}
      open={dialogAberto}
      onClose={aoFecharDialog}
      aria-labelledby="dialogTitle"
      aria-describedby="dialogDescription"
    >
      <div className={dialogClasses || null}>
        <DialogTitle id="dialogTitle">{tituloDialog}</DialogTitle>
        {textoDialog && (
          <DialogContent>
            <DialogContentText
              className={textClasses || null}
              id="dialogDescription"
            >
              {textoDialog}
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions style={{ marginBottom: 12 }}>
          <Button
            id="btnCancelaAcaoDialog"
            onClick={cancelarAcaoDialog}
            autoFocus
          >
            {t("common:actions.cancel")}
          </Button>
          <Button
            id="btnConfirmaAcaoDialog"
            onClick={() => confirmar(objetoSelecionado)}
            color="primary"
          >
            {t("common:actions.yes")}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

DialogoConfirmacaoAcao.defaultProps = {
  tituloDialog: "",
  dialogAberto: false,
};
const styles = (theme) => ({
  conteudoDialog: {
    maxWidth: 340,
  },
});
export default withStyles(styles)(DialogoConfirmacaoAcao);
